import { useGetJobListQuery } from '@/api/sanity/generated';
import { sanityLanguage } from '@/constants/language';
import { Job } from '@/types/job';

export async function getJobs() {
	const fetchJobs = useGetJobListQuery.fetcher({
		i18nLang: sanityLanguage,
	});
	const jobsData = await fetchJobs();

	const jobs: Job[] = (
		jobsData.allJobs
			.map((job) => ({ ...job, name: job.name || '', slug: { current: job.slug?.current || '' } }))
			.filter(Boolean) || []
	).slice(0, 3);

	return {
		jobs,
		total: jobsData.allJobs.length.toString(),
	};
}
